export const rules = {
    supplierType: [
        { required: true, message: '请选择主体类型', trigger: 'blur' },
    ],
    legalPersonType: [
        { required: true, message: '请选择', trigger: 'blur' },
    ],
    legalPerson: [
        { required: true, message: '姓名必填', trigger: 'blur' },
    ],
    legalId: [
        { required: true, message: '证件号必填', trigger: 'blur' },
    ],
    legalCardEndTime: [
        { required: true, message: '证件号必填', trigger: 'blur' },
    ],
    companyName: [
        { required: true, message: '公司名称必填', trigger: 'blur' },
    ],
    industryId: [
        { required: true, message: '行业类目必选', trigger: 'blur' },
    ],
    businessLicense: [
        { required: true, message: '统一社会代码必填', trigger: 'blur' },
        // { validator: validatebusinessLicense, trigger: 'blur' },
    ],
    type: [
        { required: true, message: '公司类型必填', trigger: 'blur' },
    ],
    validityPeriod: [
        { required: true, message: '营业执照-有效期', trigger: 'blur' },
    ],
    licenseStartTime: [
        { required: true, message: '营业执照有效期必填', trigger: 'blur' },
    ],
    // businessProvince: [
    //     { required: true, message: '经营省份必填', trigger: 'blur' },
    // ],
    businessDetailAddress: [
        { required: true, message: '经营地址必填', trigger: 'blur' },
    ],
    businessScope: [
        { required: true, message: '经营范围必填', trigger: 'blur' },
    ],
    appName: [
        { required: true, message: '服务名称必填', trigger: 'blur' },
    ],
    servicePhone: [
        { required: true, message: '客服电话必填', trigger: 'blur' },
    ],
    superAdminName: [
        { required: true, message: '管理员姓名必填', trigger: 'blur' },
    ],
    adminPersonId: [
        { required: true, message: '管理员身份证号必填', trigger: 'blur' },
    ],
    businessAuthorizationLetterUrl: [
        { required: true, message: '授权函必传', trigger: 'blur' },
    ],
    merchantShortname:[
        { required: true, message: '支付商家名称必填', trigger: 'blur' },
    ],
    merchantShortName: [
        { required: true, message: '支付商家名称必填', trigger: 'blur' },
    ],
    payMerchantTitleUrl: [
        { required: true, message: '支付商家头像必填', trigger: 'blur' },
    ],
    storeUrl: [
        { required: true, message: '支付商家跳转链接必填', trigger: 'blur' },
    ],
    bankAccountType: [
        { required: true, message: '类型必填', trigger: 'blur' },
    ],
    bankAccount: [
        { required: true, message: '开户名必填', trigger: 'blur' },
    ],
    accountNumber: [
        { required: true, message: '银行卡号必填', trigger: 'blur' },
        // { validator: validateBankAccount, trigger: 'blur' },
    ],
    bankName: [
        { required: true, message: '开户银行名称必填', trigger: 'blur' },
    ],
    bankBranchName: [
        { required: true, message: '开户银行名称必填', trigger: 'blur' },
    ],
    commissionRateStr: [
        { required: true, message: '技术服务费必填', trigger: 'blur' },
    ],
    poolCashPledge: [
        { required: true, message: '打款预留必填', trigger: 'blur' },
    ],
}

// function validateBankAccount(rule, value, callback) {
//     console.log(rule, 'validateBankAccount')
//     if (!value) {
//         callback(new Error('银行卡号必填'));
//     } else {
//         // 如果包含空格，则提示
//         if (value.includes(' ')) {
//             callback(new Error('银行卡号不能包含空格'));
//         }
//     }
// }
// function validatebusinessLicense(rule, value, callback) {
//     console.log(rule, 'validatebusinessLicense')
//     if (!value) {
//       callback(new Error('统一社会验证码不能为空'));
//     } else {
//         // 1、长度为2-128个字符
//         if (value.length < 2 || value.length > 128) {
//             callback(new Error('统一社会验证码长度为2-128个字符'));
//             return;
//         }
    
//         // 2、前后不能有空格、制表符、换行符
//         if (/^\s+|\s+$/.test(value)) {
//             callback(new Error('统一社会验证码前后不能有空格、制表符、换行符'));
//             return;
//         }
    
//         // 3、不能仅含数字、特殊字符
//         // 这里定义特殊字符为除字母、数字、汉字以外的字符
//         const specialCharRegex = /^[^a-zA-Z0-9\u4e00-\u9fa5]+$/;
//         if (specialCharRegex.test(value)) {
//             callback(new Error('统一社会验证码不能仅含特殊字符'));
//             return;
//         }
    
//         // 如果需要检测不能仅含数字，可以增加以下判断
//         if (/^\d+$/.test(value)) {
//             callback(new Error('统一社会验证码不能仅含数字'));
//             return;
//         }
    
//         // 4、仅能填写数字、英文字母、汉字及特殊字符
//         // 这条规则似乎与第3条规则冲突，因为第3条禁止仅含特殊字符。
//         // 如果要确保值至少包含一个字母、数字或汉字，则可以使用以下正则：
//         const validCharRegex = /^[a-zA-Z0-9\u4e00-\u9fa5]+.*$/;
//         if (!validCharRegex.test(value)) {
//             callback(new Error('统一社会验证码必须包含至少一个字母、数字或汉字'));
//             return;
//         }
    
//         // 7、个体户不能使用“企业”“公司”或“农民专业合作社”结尾
//         const forbiddenEndings = ['企业', '公司', '农民专业合作社'];
//         const endsWithForbidden = forbiddenEndings.some(ending => value.endsWith(ending));
//         if (endsWithForbidden) {
//             callback(new Error('个体户统一社会验证码不能以“企业”“公司”或“农民专业合作社”结尾'));
//             return;
//         }
    
//         // 如果所有检查都通过
//         callback();
//     }
// }